"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cerberus_MeltArmorAbilityHandler = exports.Cerberus_MeltArmorActorAbilityFactory = exports.Cerberus_MeltArmorAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class Cerberus_MeltArmorAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Cerberus_MeltArmor;
        this.__typeName = "Cerberus_MeltArmor";
    }
}
exports.Cerberus_MeltArmorAbilityArgs = Cerberus_MeltArmorAbilityArgs;
let Cerberus_MeltArmorActorAbilityFactory = class Cerberus_MeltArmorActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Cerberus_MeltArmor", "AllEnemies", 0);
    }
};
Cerberus_MeltArmorActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Cerberus_MeltArmor")
], Cerberus_MeltArmorActorAbilityFactory);
exports.Cerberus_MeltArmorActorAbilityFactory = Cerberus_MeltArmorActorAbilityFactory;
let Cerberus_MeltArmorAbilityHandler = class Cerberus_MeltArmorAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targetIds = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            projectiles: targetIds.map(targetId => ({
                targetId,
                path: "line",
                type: "FieryCerberus",
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 80)
                ],
                start: "feet",
                end: "feet",
                jitter: 0
            })),
            onHitOrMiss: (sequence, { hit }, { targetId }) => {
                sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                    : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "FireMagicCircle"));
            },
            onHit(sequence, _attack, _damages, projectile) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: projectile.targetId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_2.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FireDamageResistance, 50),
                });
                const buff = (0, Random_1.randomElement)(container.getHelpfulEffects(projectile.targetId, false));
                if (buff) {
                    container.cancelEffect(sequence, buff.id);
                }
            },
        });
    }
};
Cerberus_MeltArmorAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Cerberus_MeltArmor)
], Cerberus_MeltArmorAbilityHandler);
exports.Cerberus_MeltArmorAbilityHandler = Cerberus_MeltArmorAbilityHandler;
